import Tooltip from "@mui/material/Tooltip";
import MuiTypography from "@mui/material/Typography";
import { MvTypographyPropsInterface } from "@mv-components/types";

const Typography = (props: MvTypographyPropsInterface) => {
	const { children, trimLimit, tooltipPlacement = "right", tooltipText, ...rest } = props;
	let _children = children;

	if (trimLimit && typeof _children === "string") {
		if (_children.length > trimLimit) {
			_children = (
				<Tooltip title={_children} placement={tooltipPlacement}>
					{<span>{_children.substring(0, trimLimit - 1) + "..."}</span>}
				</Tooltip>
			);
		}
	}

	if (tooltipText) {
		_children = (
			<Tooltip title={tooltipText} placement={tooltipPlacement}>
				{<span>{children}</span>}
			</Tooltip>
		);
	}

	return <MuiTypography {...rest}>{_children}</MuiTypography>;
};

export default Typography;
